import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IModalContent, TOfferType } from '../../../types';
import { openAuthorizationModal, closeModal, openModal } from '../../../redux';
import { selectIsOpenModal, selectModalContent, selectModalType } from '../../../selectors/modal';

interface IUseInfoModal {
  isModalOpen: boolean;
  modalContent: IModalContent | null;
  modelType: TOfferType | null;
  handleCloseModal: () => void;
  handleOpenModal: () => void;
  handleOpenAuthModal: (redirectUrl: string) => void;
}

export const useInfoModal = (): IUseInfoModal => {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(selectIsOpenModal);
  const modalContent = useSelector(selectModalContent);
  const modelType = useSelector(selectModalType);

  const handleCloseModal = React.useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  const handleOpenModal = React.useCallback(() => {
    dispatch(
      openModal({
        content: modalContent,
        type: modelType,
      }),
    );
  }, [dispatch, modalContent, modelType]);

  const handleOpenAuthModal = React.useCallback(
    (redirectUrl: string) => {
      dispatch(closeModal());
      dispatch(openAuthorizationModal({ redirectUrl }));
    },
    [dispatch],
  );

  return {
    isModalOpen,
    modelType,
    modalContent,
    handleCloseModal,
    handleOpenModal,
    handleOpenAuthModal,
  };
};
